import React from 'react';

import Fieldset from '../components/Fieldset';
import getComponentDisplayName from './getComponentDisplayName';


export default function withFieldset(Component) {
    function WrappedComponent(props) {
        return (
            <Fieldset>
                <Component {...props} />
            </Fieldset>
        );
    }

    WrappedComponent.displayName = `withFieldset(${getComponentDisplayName(Component)})`;

    return WrappedComponent;
}